(() => {
  'use strict';

  // The previous banner only stored its dismissal, not valid tracking consent.
  // Shopify's Customer Privacy API is now the sole source of consent decisions.
  try {
    localStorage.removeItem('eu-cookie-confirm');
  } catch (_) {
    // Cookie settings must still open when browser storage is unavailable.
  }

  let previousConsent;

  function removeCookies(names) {
    const hostname = window.location.hostname;
    const domains = ['', hostname, ...hostname.split('.').map((_, index, parts) =>
      `.${parts.slice(index).join('.')}`)].filter((domain) => !domain || domain.includes('.'));

    names.forEach((name) => domains.forEach((domain) => {
      document.cookie = `${name}=; Max-Age=0; path=/;${domain ? ` domain=${domain};` : ''} SameSite=Lax; Secure`;
    }));
  }

  function updateTracking() {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy) return;

    const consent = privacy.currentVisitorConsent();
    const marketing = consent.marketing === 'yes' && privacy.marketingAllowed();
    const withdrawn = previousConsent && ['analytics', 'marketing', 'preferences'].some((category) =>
      previousConsent[category] === 'yes' && consent[category] !== 'yes');

    // Clarity has been removed; expire its remaining first-party identifiers.
    removeCookies(['_clck', '_clsk']);
    if (!marketing) removeCookies(['_fbp', '_fbc', 'mc_track', 'mc_customer_session_id']);
    previousConsent = consent;

    // Reload after withdrawal to unload SDKs whose permission promises have
    // already resolved. Shopify has persisted the new choice before this event.
    if (withdrawn) {
      window.location.reload();
      return;
    }

  }

  document.addEventListener('visitorConsentCollected', updateTracking);
  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (!error) updateTracking();
    });
  }

  let bannerPromise;

  function loadBanner() {
    if (window.privacyBanner?.showPreferences) {
      return Promise.resolve(window.privacyBanner);
    }

    if (!bannerPromise) {
      bannerPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        let timeout;

        function fail() {
          clearTimeout(timeout);
          script.remove();
          reject(new Error('Cookie settings are unavailable.'));
        }

        script.src = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
        script.async = true;
        script.onload = () => {
          clearTimeout(timeout);
          if (window.privacyBanner?.showPreferences) {
            resolve(window.privacyBanner);
          } else {
            fail();
          }
        };
        script.onerror = fail;
        timeout = setTimeout(fail, 10000);
        document.head.appendChild(script);
      }).catch((error) => {
        bannerPromise = undefined;
        throw error;
      });
    }

    return bannerPromise;
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cookie-settings]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;

    const status = button.closest('.site-footer')?.querySelector('[data-cookie-settings-status]');
    button.setAttribute('aria-busy', 'true');
    if (status) status.hidden = true;

    try {
      const banner = await loadBanner();
      await banner.showPreferences();
    } catch (_) {
      if (status) {
        status.textContent = 'Cookie settings could not be opened. Please try again.';
        status.hidden = false;
      }
    } finally {
      button.removeAttribute('aria-busy');
    }
  });
})();
